import { shellStringResources } from '../../Resources/ShellStringResources';
import { writeBehaviorOptionValues } from '../../constants/write-behavior-constants';
import { isTridentInIframe } from '../../shared/utils/iframe.utils';
import { IAttribute, IModel, IViolation } from '../base/annotation';
import { Metamodel } from '../base/model';
import { SalesforceServiceCloudDataset } from '../dataset/salesforce-service-cloud.dataset';
import { ModelConstants } from '../model-constants';
import { CopySink } from './copysink';

@Metamodel.model({
    name: ModelConstants.salesforceServiceCloudCopySink,
    disabled: isTridentInIframe(),
    display: [],
    referable: true,
    tags: { datasetModel: Metamodel.modelFor(SalesforceServiceCloudDataset) }
})
export class SalesforceServiceCloudSink extends CopySink {
    public static readonly MODEL: IModel;
    public static readonly WRITE_BEHAVIOR: IAttribute;
    public static readonly WRITE_BATCH_SIZE: IAttribute;
    public static readonly EXTERNAL_ID_FIELD_NAME: IAttribute;
    public static readonly IGNORE_NULL_VALUES: IAttribute;

    @Metamodel.attribute({
        templatable: true,
        association: 'WRITE_BEHAVIOR',
        display: shellStringResources.ModelName_WriteBehavior
    })
    public writeBehavior?: string = writeBehaviorOptionValues.insert;

    @Metamodel.attribute({
        templatable: true,
        association: 'EXTERNAL_ID_FIELD_NAME',
        display: shellStringResources.ModelName_SalesforceExternalIdFieldName,
        constraint: {
            validator: SalesforceServiceCloudSink.validateExternalIdFieldName
        }
    })
    public externalIdFieldName?: string;
    @Metamodel.attribute({
        templatable: true,
        association: 'WRITE_BATCH_SIZE',
        display: shellStringResources.ModelName_WriteBatchSize
    })
    public writeBatchSize?: number = 5000;
    @Metamodel.attribute({
        templatable: true,
        association: 'IGNORE_NULL_VALUES',
        display: shellStringResources.ModelName_IgnoreNullValues
    })
    public ignoreNullValues?: boolean;

    private static validateExternalIdFieldName(salesforceServiceCloudSink: SalesforceServiceCloudSink, externalIdFieldName?: string): IViolation[] | undefined {
        if (salesforceServiceCloudSink.writeBehavior && (salesforceServiceCloudSink.writeBehavior.toLowerCase() === writeBehaviorOptionValues.upsert) && !externalIdFieldName) {
            return [
                {
                    message: () => shellStringResources.SalesforceExternalIdFieldNameMissingError
                }
            ];
        }
        return undefined;
    }
}
